//
import PromoModel from '../../../models/Warehouse/WhPromo'
/**
 *
 */
const fetchById = async id => {
    //
    const includes = ['wh_product', 'wh_products_promo'],
        appends = [
            // 'sale_prices',
            // 'composition',
            // 'stocks',
            // 'discounts',
            // 'branch_offices',
        ]

    //
    try {
        //
        let promo = await PromoModel.include(includes)
            .append(appends)
            .find(id)

        //
        return promo
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchById
